import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select, Space } from 'antd';
import { PageHeader } from '../../components/common/PageHeader';
import { DataTable } from '../../components/common/DataTable';
import { StatusBadge } from '../../components/common/StatusBadge';
import { useTicketsList } from '../../hooks/useSupport';
import { TICKET_STATUS_COLORS, TICKET_PRIORITY_COLORS } from '../../lib/constants';
import dayjs from 'dayjs';
import type { AdminTicketListItem } from '../../types/support';
import type { ColumnsType } from 'antd/es/table';

export function TicketsListPage() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, per_page: 20, search: '', status: undefined as string | undefined, priority: undefined as string | undefined });
  const { data, isLoading } = useTicketsList(params);

  const columns: ColumnsType<AdminTicketListItem> = [
    { title: '#', dataIndex: 'ticket_number', key: 'num', render: (v: string, r) => <a onClick={() => navigate(`/support/tickets/${r.id}`)}>{v}</a> },
    { title: 'Subject', dataIndex: 'subject', key: 'subject', ellipsis: true },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (v: string) => <StatusBadge status={v} colorMap={TICKET_STATUS_COLORS} /> },
    { title: 'Priority', dataIndex: 'priority', key: 'priority', render: (v: string) => <StatusBadge status={v} colorMap={TICKET_PRIORITY_COLORS} /> },
    { title: 'Assignee', dataIndex: 'assigned_to_name', key: 'assignee', render: (v: string | null) => v || '-' },
    { title: 'Created', dataIndex: 'created_at', key: 'created', render: (v: string) => dayjs(v).format('MMM D, YYYY') },
  ];

  return (
    <>
      <PageHeader title="Support Tickets" subtitle={`${data?.total ?? 0} tickets`} />
      <DataTable<AdminTicketListItem>
        columns={columns} dataSource={data?.data} loading={isLoading} total={data?.total} page={params.page} perPage={params.per_page}
        onPageChange={(p, ps) => setParams((s) => ({ ...s, page: p, per_page: ps }))}
        onSearch={(v) => setParams((s) => ({ ...s, search: v, page: 1 }))}
        extra={
          <Space>
            <Select placeholder="Status" allowClear style={{ width: 150 }} onChange={(v) => setParams((s) => ({ ...s, status: v, page: 1 }))} options={['open', 'in_progress', 'waiting_on_customer', 'resolved', 'closed'].map((s) => ({ label: s.replace(/_/g, ' '), value: s }))} />
            <Select placeholder="Priority" allowClear style={{ width: 120 }} onChange={(v) => setParams((s) => ({ ...s, priority: v, page: 1 }))} options={['low', 'normal', 'high', 'urgent'].map((p) => ({ label: p, value: p }))} />
          </Space>
        }
      />
    </>
  );
}
